import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import Header from "../Header";
import "./index.css";

const LeadUsers = () => {
  const tableRef = useRef(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatingUser, setUpdatingUser] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null); // State for success message
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://apiaksharaconnect.aksharafinalytics.in/leadusers");
        if (!response.ok) {
          throw new Error("Failed to fetch data from the server");
        }
        const data = await response.json();
        
        setUserData(data.user || []);
        
        setLoading(false);
      } catch (err) {
        setError(err.message || "Error fetching data");
        setLoading(false);
      }
    };

    fetchData();

    // Check for success message in localStorage after page reload
    const storedSuccessMessage = localStorage.getItem('successMessage');
    if (storedSuccessMessage) {
      setSuccessMessage(storedSuccessMessage);
      localStorage.removeItem('successMessage'); // Clear the success message after displaying
    }

  }, []);

  const handleTakeover = async (userId) => {
    const mgrId = localStorage.getItem("userId");
    
    if (!mgrId) {
      alert("Manager ID is not available.");
      return;
    }

    const isConfirmed = window.confirm("Are you sure you want to take over this user?");
    if (!isConfirmed) {
      return; // Do nothing if the user cancels the confirmation
    }

    setUpdatingUser(userId);
    setCurrentUserId(userId); // Set current user ID

    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/assign/${userId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({  
          mgr_id: mgrId
        })
      });

      if (!response.ok) {
        throw new Error("Failed to assign manager to the user");
      }

      // Set success message in localStorage after successful takeover
      const successMsg = `User has been taken over successfully!`;
      localStorage.setItem('successMessage', successMsg);

      setUpdatingUser(null);

      // Optionally, refresh the table data or do something else
      window.location.reload(); // Reload to trigger the success message after reload

    } catch (err) {
      alert("Error while assigning manager: " + err.message);
      setUpdatingUser(null);
    }
  };

  useEffect(() => {
    if (tableRef.current && userData) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true,
        paging: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
          { targets: 5, responsivePriority: 6 },
          { targets: 6, responsivePriority: 7 },
        ],
      });

      return () => {
        table.destroy();
      };
    }
  }, [userData]);

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <div className="container-fluid mt-4">
        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>Lead Users Details</h4>
          </div>
          <div className="card-body">

            {/* Display the success message if it's set */}
            {successMessage && (
              <div className="alert alert-success">
                {successMessage}
              </div>
            )}
            {error && <div className="alert alert-danger">{error}</div>}

            {currentUserId && (
              <div className="alert alert-info">
                Processing takeover for User ID: {currentUserId}
              </div>
            )}

            

            {userData ? (
              <div className="table-responsive">
                <table
                  ref={tableRef}
                  className="table table-striped table-bordered display nowrap"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>S.no</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Amount</th>
                      <th>Plan</th>
                      <th>Payment Status</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData.length > 0 ? (
                      userData.map((user, index) => (
                        <tr key={user.id || index}>
                          <td>{index + 1}</td>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          <td>{user.phone}</td>
                          <td>{user.amount}</td>
                          <td>{user.plan}</td>
                          <td>{user.paymentstatus}</td>
                          <td>{user.date}</td>
                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => handleTakeover(user.id)}
                              disabled={updatingUser === user.id}
                            >
                              {updatingUser === user.id ? "Assigning..." : "Takeover"}
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : null}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadUsers;
